import * as React from 'react';
import FilterOptionForm from "../../components/FilterOptions/FilterOptionForm/FilterOptionForm";
var FilterOption = function () {
    return (React.createElement("div", { className: "container-fluid" },
        React.createElement("div", { className: "animated fadeIn" },
            React.createElement("h1", { className: "display-3" }, "\u041D\u043E\u0432 \u0444\u0438\u043B\u0442\u044A\u0440"),
            React.createElement("hr", null),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-md-5 offset-md-4" },
                    React.createElement(FilterOptionForm, null))))));
};
export default FilterOption;



//////////////////
// WEBPACK FOOTER
// ./src/views/FilterOptions/FilterOption.tsx
// module id = 351
// module chunks = 0